import { matchPath, useLocation } from 'react-router-dom';

export default function useRouterMatch(options = {}) {
  const location = useLocation();

  return !!matchPath(options, location.pathname);
}
